import React from 'react';
import { isArray, isString } from 'lodash';
import { IQuestionnaireResultTableItem } from '../../Models/Questionnaire/IQuestionnaireResultTableItem';
// @ts-ignore
import styles from './QuestionnaireResultTableItem.module.scss';
import Tooltip from '../Popup/Tooltip';
import useTranslation from '../../Hooks/useTranslation';
import { joinClasses } from '../../Utils/className.util';

const QuestionnaireResultTableItem: React.FC<IQuestionnaireResultTableItem> = ({
	value,
	diff,
	color = '#fff',
	textColor = '#000',
	source,
	className,
}) => {
	const { t } = useTranslation();

	let item = (
		<div
			className={joinClasses([styles.wrapper, className])}
			style={{ backgroundColor: color }}>
			<div className={styles.value} style={{ color: textColor }}>
				{value}
			</div>
			{diff && <div className={styles.diff}>{diff}</div>}
		</div>
	);

	if (isArray(value)) {
		item = (
			<div
				className={joinClasses([styles.wrapper, className])}
				style={{ backgroundColor: color }}>
				{value.map(({ value: item }, index) => (
					<div
						key={index}
						className={styles.value}
						style={{ color: textColor }}>
						{t(`base.${item}`)}
					</div>
				))}
			</div>
		);
	}

	if (isString(value)) {
		item = (
			<div
				className={joinClasses([styles.wrapper, className])}
				style={{ backgroundColor: color }}>
				<div className={styles.value} style={{ color: textColor }}>
					{value}
				</div>
			</div>
		);
		if (value.startsWith('data:image')) {
			item = (
				<div
					className={joinClasses([styles.wrapper, className])}
					style={{ backgroundColor: color }}>
					<div className={styles.value} style={{ color: textColor }}>
						<img src={value} width='100%' alt='Image drawen by patient' />
					</div>
				</div>
			);
		}
	}

	if (Number.isNaN(value)) {
		item = <></>;
	}

	if (source) {
		return (
			<Tooltip
				customStyle={{ width: '100%' }}
				trigger={item}
				position='bottom center'>
				{t('base.source')}: {source}
			</Tooltip>
		);
	}

	return item;
};

export default QuestionnaireResultTableItem;
